module.exports = __webpack_public_path__ + "static/media/Adv-Testing-Short-Gif.45f08379.gif";